import OrderDetailsConfig from '../../table/configs/loading-orders-details-serials.json';
import {ActivatedRoute} from '@angular/router';
import {CommandAccessoriesDialogComponent} from './command-accessories-dialog/command-accessories-dialog.component';
import {CommonService} from '../../services/common.service';
import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material';

@Component({
  templateUrl: './loading-order-details-info.component.html'
})
export class LoadingOrderDetailsInfoComponent implements OnInit {
  public orderDetailsConfig: any;
  public orderDetailsSerials: any;
  details: any;
  public data: any;
  public pageInitialized: boolean;
  private commandDetailsID: number;
  constructor(private activatedRoute: ActivatedRoute,
              private commonService: CommonService,
              private matDialog: MatDialog) {
    this.pageInitialized = false;
    this.data = [];
    this.orderDetailsSerials = JSON.parse(localStorage.getItem('orderDetailsSerials'));
  }

  public async ngOnInit(): Promise<any> {
    this.activatedRoute.params.subscribe(async (params) => {
      this.commandDetailsID = params.id;
      this.data = await this.commonService.getSimpleList(`loading_command/web/basic_info/${params.id}`);
      this.orderDetailsSerials = this.orderDetailsSerials ? this.orderDetailsSerials : this.data;
      this.orderDetailsConfig = OrderDetailsConfig;
      this.orderDetailsConfig.filter = `command_details_id=${params.id}`;
      this.details = await this.commonService.getListWithParameters('loading_command/web/details/serial_numbers', `command_details_id=${params.id}`);
      this.pageInitialized = true;
    });
  }

  public canShowCasesButton() {
    return this.data && this.data.order_type_id === 2;
  }

  public openCasesDialog() {
    this.matDialog.open(CommandAccessoriesDialogComponent, {
      data: {
        commandDetailID: this.commandDetailsID
      }
    });
  }

}
